import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@babackapp/ui/components/avatar";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import {
  resolvePeople,
  type ShopPerson,
  useShopPeople,
} from "@/lib/people/use-shop-people";
import AssignedMembersCombobox from "./assigned-members-combobox.tsx";

type AssignedMembersProps = {
  returnRequest: ReturnRequestDto;
};

type MemberLineProps = {
  member: ShopPerson;
};

function MemberLine({ member }: MemberLineProps) {
  const memberName = member.displayName;

  return (
    <div className="flex items-center space-x-2">
      <Avatar className="mr-2 h-6 w-6">
        <AvatarImage src={member.user?.logoUrl ?? ""} alt={memberName} />
        <AvatarFallback>{memberName.charAt(0)}</AvatarFallback>
      </Avatar>
      <span className="text-sm font-medium">{memberName}</span>
    </div>
  );
}

export default function AssignedMembers({
  returnRequest,
}: AssignedMembersProps) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  // Members and Baback support alike (BAB-3035).
  const people = useShopPeople();

  return (
    <div>
      <div className="flex flex-col gap-2">
        <div className="space-y-2 my-2">
          {resolvePeople(
            people,
            returnRequest.assignedUsers,
            t("superAdmin.unknownUser"),
          ).map((member) => (
            <MemberLine key={member.userId} member={member} />
          ))}
        </div>
      </div>
      <div>
        <AssignedMembersCombobox returnRequest={returnRequest} shop={shop} />
      </div>
    </div>
  );
}
